/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings';

/**
* Properties of the original GCP Cloud SQL instance. Present only when `resourceType` is set to `GCP_CLOUDSQL`. 
*/
export class GcpCloudSqlResource {
  /**
  * Total database storage size, in bytes.
  */
  'sizeBytes': number;
  /**
  * Database engine.
  */
  'engine': string;
  /**
  * Database engine version.
  */
  'engineVersion': string;
  'storageSettings'?: GcpCloudSqlResourceStorageSettings;
  /**
  * Cloud SQL instance tier.
  */
  'instanceTier': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "engine",
      "baseName": "engine",
      "type": "string",
      "format": ""
    },
    {
      "name": "engineVersion",
      "baseName": "engineVersion",
      "type": "string",
      "format": ""
    },
    {
      "name": "storageSettings",
      "baseName": "storageSettings",
      "type": "GcpCloudSqlResourceStorageSettings",
      "format": ""
    },
    {
      "name": "instanceTier",
      "baseName": "instanceTier",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpCloudSqlResource.attributeTypeMap;
  }

  public constructor() {
  }
}

